import React from 'react'
import styles from './styles.css'

export default function Home(props) {
  return (
    <div className={styles.container}>
      <div className={styles.logo} />
    </div>
  )
}
